import { gatherNextBlogPosts, sortBlogPosts } from '../utils';

const useBlogPosts = () => {
  const allNextBlogPosts = gatherNextBlogPosts();

  const blogPosts = sortBlogPosts(allNextBlogPosts);

  const categories = [...new Set([...allNextBlogPosts.map((post) => post.Categories).flat()])].filter(
    (cat) => cat !== 'Product news'
  );

  return {
    blogPosts,
    categories
  };
};

export default useBlogPosts;
